import { cn } from "@/lib/cn";
import { TONE, type Tone } from "./tones";

export function Badge({
  tone = "neutral",
  dot = false,
  className,
  children,
}: {
  tone?: Tone;
  /** 라벨 앞 선행 색점 표시 */
  dot?: boolean;
  className?: string;
  children: React.ReactNode;
}) {
  const t = TONE[tone];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold",
        className
      )}
      style={{ background: t.soft, color: t.fg }}
    >
      {dot && (
        <span
          className="inline-block h-1.5 w-1.5 shrink-0 rounded-full"
          style={{ background: t.dot }}
        />
      )}
      {children}
    </span>
  );
}
